import { show_toast, hide_toast, get_toast_content, show_help } from '../actions/types';

const INITIAL_STATE = {
  content: null,
  shown: false,
  left: false,
  helpShown: true
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case get_toast_content:
      return { ...state, content: action.payload };
    case show_toast:
      return { ...state, shown: true, left: action.payload };
    case hide_toast: return { ...state, contnet: null, shown: false, left: false };
    case show_help: {
      const isShown = state.helpShown;
      return { ...state, helpShown: !isShown };
    }
    default: return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/ToastReducer.js